/* unplugin-vue-components disabled */import script from "./blkPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./blkPagination.vue?vue&type=script&setup=true&lang=js"

import "./blkPagination.vue?vue&type=style&index=0&id=230c2eef&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-230c2eef"]])

export default __exports__